module.exports = __webpack_public_path__ + "media/add/add3-2-a136e17a.jpg";